import { UNIT_LABELS, type UnitCounts, type UnitKey } from '../api/types';

/** Reihenfolge wie im Spiel selbst: Nahkampf vor Fernkampf vor Kavallerie vor Belagerung vor Adel. */
const UNIT_ORDER: UnitKey[] = [
  'spear',
  'sword',
  'axe',
  'archer',
  'spy',
  'light',
  'marcher',
  'heavy',
  'ram',
  'catapult',
  'knight',
  'snob',
  'militia',
];

/**
 * Truppentabelle wie im Spiel: Einheiten-Icons als Spaltenköpfe, darunter
 * Bestand und (sofern `showLosses`) Verlust. Zeigt nur Einheitentypen, die
 * diese Welt überhaupt kennt (also in `units` ODER `losses` vorkommen),
 * damit z. B. eine Welt ohne Bogenschützen keine leere Spalte bekommt.
 *
 * `showLosses` ist bewusst ein eigener Schalter statt einfach `losses` wegzulassen:
 * eine reine Bestandsangabe (z. B. Truppen des Verteidigers, die anderswo
 * standen -- die haben in diesem Bericht gar nicht mitgekämpft, "Verlust"
 * ergibt für sie keinen Sinn) ist etwas anderes als "keine Verlusttabelle
 * lesbar" (dafür bleibt `losses` weiterhin `null`, mit sichtbarer 0-Zeile).
 */
export function UnitTable({
  units,
  losses,
  showLosses = true,
}: {
  units: UnitCounts | null;
  losses?: UnitCounts | null;
  showLosses?: boolean;
}) {
  const present = UNIT_ORDER.filter((key) => key in (units ?? {}) || key in (losses ?? {}));
  if (present.length === 0) return <p className="muted">Keine Truppenangaben.</p>;

  return (
    <table className="unit-table">
      <thead>
        <tr>
          <th />
          {present.map((key) => (
            <th key={key} title={UNIT_LABELS[key]}>
              <img src={`/icons/unit/${key}.webp`} alt={UNIT_LABELS[key]} />
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        <tr>
          <th>Bestand</th>
          {present.map((key) => (
            <td key={key}>{(units?.[key] ?? 0).toLocaleString('de-DE')}</td>
          ))}
        </tr>
        {showLosses && (
          <tr>
            <th>Verlust</th>
            {present.map((key) => (
              <td key={key}>{(losses?.[key] ?? 0).toLocaleString('de-DE')}</td>
            ))}
          </tr>
        )}
      </tbody>
    </table>
  );
}
